import { useClient } from "../../../hooks/use-client";
import useSite from "../../permits/components/inspections/InspectionPanel/useSite";

export const useCustomTerms = () => {
  const site = useSite();
  const client = useClient(site);
  const goGovTermsUrl = "https://www.gogovapps.com/terms";
  const termsUrl = client.query.data?.payload.data.attributes["terms-url"] || "";
  return {
    cityTermsUrl: termsUrl,
    goGovTermsUrl: goGovTermsUrl,
    cityName: client.query.data?.payload.data.attributes.name || "",
  };
};
